import { render, staticRenderFns } from "./OrderListPickupSuccess.vue?vue&type=template&id=cd954fe6&scoped=true"
import script from "./OrderListPickupSuccess.vue?vue&type=script&lang=js"
export * from "./OrderListPickupSuccess.vue?vue&type=script&lang=js"
import style0 from "./OrderListPickupSuccess.vue?vue&type=style&index=0&id=cd954fe6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd954fe6",
  null
  
)

export default component.exports